import React from 'react';
export function Modulo4Page() {
  return <div className="min-h-screen bg-[#0a0a0a] text-[#e0e0e0] font-body" data-id="element-1084">
      {/* TOP NAV */}
      <nav className="sticky top-0 z-[100] flex h-[56px] items-center justify-between border-b border-[#1a1a1a] bg-black px-4 md:px-10" data-id="element-1085">
        <div className="font-heading text-[13px] font-black tracking-[3px] text-white uppercase" data-id="element-1086">
          AI <span className="text-[#F5C842]" data-id="element-1087">WEB CLOSER</span>
        </div>
        <div className="flex gap-1 overflow-x-auto" data-id="element-1088">
          <a href="/modulo-1" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1089">
            Módulo 1
          </a>
          <a href="/modulo-2" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1090">
            Módulo 2
          </a>
          <a href="/modulo-3" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1091">
            Módulo 3
          </a>
          <a href="/modulo-4" className="rounded bg-[#F5C842] px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-black transition-all" data-id="element-1092">
            Módulo 4
          </a>
          <a href="/calculadora" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#F5C842] transition-all hover:bg-[#1a1a1a] border border-[#F5C842]/30" data-id="element-1093">
            Calculadora
          </a>
        </div>
      </nav>

      {/* HERO */}
      <div className="border-b-[3px] border-[#F5C842] bg-gradient-to-br from-black to-[#0d0d0d] px-6 py-10 md:px-20 md:py-[60px] md:pb-[50px]" data-id="element-1094">
        <div className="mb-5 flex items-center gap-2.5" data-id="element-1095">
          <div className="rounded-sm bg-[#F5C842] px-3.5 py-1 font-heading text-[9px] font-black tracking-[3px] text-black uppercase" data-id="element-1096">
            Módulo 4 de 4 — Final
          </div>
          <div className="text-[11px] tracking-[2px] text-[#444] uppercase" data-id="element-1097">
            ⏱ 15 minutos · El Guion de Cierre Completo
          </div>
        </div>
        <div className="mb-4 font-heading text-4xl md:text-[48px] font-black leading-[1.05] text-white" data-id="element-1098">
          El Cierre
          <br data-id="element-1099" />
          <span className="text-[#F5C842]" data-id="element-1100">Sin Presión</span>
        </div>
        <div className="mb-8 max-w-[600px] text-[15px] leading-[1.7] text-[#888]" data-id="element-1101">
          El guion exacto para convertir una conversación casual en una venta de
          $350. No es una venta — es una conversación. Y tienes algo que ellos
          quieren.
        </div>
        <div className="flex flex-col md:flex-row gap-4 md:gap-6" data-id="element-1102">
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1103">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1104"></div>
            Guion de apertura + seguimiento
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1105">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1106"></div>
            Las 5 objeciones y cómo responderlas
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1107">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1108"></div>
            Estrategia de precios y plan de pagos
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="mx-auto max-w-[1100px] px-4 py-10 md:px-10 md:py-[50px]" data-id="element-1109">
        {/* VIDEO */}
        <div className="mb-10" data-id="element-1110">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1111">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1112"></span>
            Video del Módulo
          </div>
          <a href="#" className="group block overflow-hidden rounded-[10px] border-2 border-[#1e1e1e] transition-all duration-250 hover:-translate-y-0.5 hover:border-[#F5C842]" data-id="element-1113">
            <div className="relative flex h-[280px] flex-col items-center justify-center overflow-hidden" style={{
            backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 40px, rgba(245,200,66,0.015) 40px, rgba(245,200,66,0.015) 41px), linear-gradient(135deg, #0d0d0d 0%, #141414 50%, #0a0a0a 100%)'
          }} data-id="element-1114">
              <div className="absolute inset-x-0 bottom-0 h-[80px] bg-gradient-to-t from-black/60 to-transparent" data-id="element-1115"></div>
              <div className="relative z-10 mb-5 flex h-[80px] w-[80px] items-center justify-center rounded-full border-[3px] border-[#F5C842]" data-id="element-1116">
                <div style={{
                width: 0,
                height: 0,
                borderTop: '14px solid transparent',
                borderBottom: '14px solid transparent',
                borderLeft: '24px solid #F5C842',
                marginLeft: '6px'
              }} data-id="element-1117"></div>
              </div>
              <div className="relative z-10 px-10 text-center font-heading text-[20px] font-black text-white" data-id="element-1118">
                MÓDULO 4 — El Cierre Sin Presión
              </div>
              <div className="relative z-10 mt-2 text-[11px] text-[#555]" data-id="element-1119">
                Haz clic para ver el video en Google Drive
              </div>
            </div>
            <div className="flex items-center justify-between bg-[#F5C842] px-6 py-3" data-id="element-1120">
              <span className="font-heading text-[11px] font-black tracking-[1px] text-black uppercase" data-id="element-1121">
                ▶ Ver Video Completo — Google Drive
              </span>
              <span className="font-heading text-[16px] font-black text-black" data-id="element-1122">
                →
              </span>
            </div>
          </a>
        </div>

        {/* MINDSET BANNER */}
        <div className="mb-8 rounded-r-lg border border-[#2a2a2a] border-l-[4px] border-l-[#F5C842] bg-gradient-to-br from-[#0d0d0d] to-[#111] px-7 py-6" data-id="element-1123">
          <div className="mb-2 font-heading text-[16px] font-black text-[#F5C842]" data-id="element-1124">
            &#x1F4A1; El Cambio de Mentalidad que lo Cambia Todo
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1125">
            Sé que para muchos esta es la parte más intimidante. Llamar a un
            extraño y ofrecerle algo. Pero cuando termines este módulo, vas a
            ver que{' '}
            <strong className="text-white" data-id="element-1126">
              no es una venta. Es una conversación.
            </strong>{' '}
            Y tienes algo que ellos quieren — su negocio representado de forma
            profesional en internet.
          </div>
        </div>

        {/* SCRIPT CARDS */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1127">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1128"></span>
          El Guion de Cierre — Copiar y Pegar
        </div>

        {/* PASO 1 */}
        <div className="mb-5 overflow-hidden rounded-[10px] border border-[#2a2a2a] bg-black" data-id="element-1129">
          <div className="flex items-center gap-2.5 border-b border-[#1e1e1e] bg-[#111] px-[22px] py-3.5" data-id="element-1130">
            <span className="text-[18px]" data-id="element-1131">📱</span>
            <span className="font-heading text-[13px] font-black text-white" data-id="element-1132">
              PASO 1 — Apertura (WhatsApp o llamada)
            </span>
            <span className="ml-auto text-[10px] text-[#555]" data-id="element-1133">
              ⏱ Primer contacto
            </span>
          </div>
          <div className="whitespace-pre-wrap px-[22px] py-[22px] text-[13px] italic leading-[1.85] text-[#ccc]" data-id="element-1134">
            "Hola, ¿hablo con{' '}
            <span className="italic text-[#666]" data-id="element-1135">[Nombre del dueño]</span>? Mi
            nombre es <span className="italic text-[#666]" data-id="element-1136">[Tu nombre]</span>.
            Vi su negocio{' '}
            <span className="italic text-[#666]" data-id="element-1137">[Nombre del negocio]</span> en
            Google Maps y noté que no tienen sitio web. Tomé 10 minutos y
            preparé una demo de cómo podría verse. ¿Le puedo enviar el link para
            que lo vea?"
            <br data-id="element-1138" />
            <br data-id="element-1139" />
            <span className="not-italic font-bold text-white" data-id="element-1140">
              — Eso es todo. No vendas nada todavía. Solo pide permiso para
              enviar el link.
            </span>
            <br data-id="element-1141" />
            <span className="not-italic font-bold text-white" data-id="element-1142">
              — La mayoría dirá que sí porque es gratis y no les pides nada.
            </span>
          </div>
        </div>

        {/* PASO 2 */}
        <div className="mb-5 overflow-hidden rounded-[10px] border border-[#2a2a2a] bg-black" data-id="element-1143">
          <div className="flex items-center gap-2.5 border-b border-[#1e1e1e] bg-[#111] px-[22px] py-3.5" data-id="element-1144">
            <span className="text-[18px]" data-id="element-1145">⏳</span>
            <span className="font-heading text-[13px] font-black text-white" data-id="element-1146">
              PASO 2 — Envía la demo y espera
            </span>
            <span className="ml-auto text-[10px] text-[#555]" data-id="element-1147">
              ⏱ Inmediatamente después
            </span>
          </div>
          <div className="whitespace-pre-wrap px-[22px] py-[22px] text-[13px] italic leading-[1.85] text-[#ccc]" data-id="element-1148">
            Cuando digan que sí,{' '}
            <span className="not-italic font-bold text-[#F5C842]" data-id="element-1149">
              envía el link de la demo
            </span>{' '}
            que construiste en el Módulo 3.
            <br data-id="element-1150" />
            <br data-id="element-1151" />
            <span className="not-italic font-bold text-white" data-id="element-1152">
              Espera exactamente 10 minutos.
            </span>
            <br data-id="element-1153" />
            <br data-id="element-1154" />
            No escribas antes. No preguntes si la vieron. Espera los 10 minutos
            y luego envía el seguimiento.
          </div>
        </div>

        {/* PASO 3 */}
        <div className="mb-8 overflow-hidden rounded-[10px] border border-[#2a2a2a] bg-black" data-id="element-1155">
          <div className="flex items-center gap-2.5 border-b border-[#1e1e1e] bg-[#111] px-[22px] py-3.5" data-id="element-1156">
            <span className="text-[18px]" data-id="element-1157">💰</span>
            <span className="font-heading text-[13px] font-black text-white" data-id="element-1158">
              PASO 3 — Seguimiento y cierre
            </span>
            <span className="ml-auto text-[10px] text-[#555]" data-id="element-1159">
              ⏱ 10 minutos después de enviar la demo
            </span>
          </div>
          <div className="whitespace-pre-wrap px-[22px] py-[22px] text-[13px] italic leading-[1.85] text-[#ccc]" data-id="element-1160">
            "¿Tuvo oportunidad de verlo? ¿Qué le pareció? Puedo tenerlo listo y
            publicado en{' '}
            <span className="not-italic font-bold text-[#F5C842]" data-id="element-1161">
              48 horas por $350
            </span>
            . Incluye el dominio y el primer mes de hosting."
            <br data-id="element-1162" />
            <br data-id="element-1163" />
            <span className="not-italic font-bold text-white" data-id="element-1164">
              Si dicen que sí → cobras.
            </span>
            <br data-id="element-1165" />
            <span className="not-italic font-bold text-white" data-id="element-1166">
              Si dicen que es caro → ofrece plan de pagos: $175 ahora, $175 en
              30 días.
            </span>
            <br data-id="element-1167" />
            <span className="not-italic font-bold text-white" data-id="element-1168">
              Si siguen sin cerrar → pasa al siguiente prospecto. No negocies
              demasiado. Tu tiempo vale.
            </span>
          </div>
        </div>

        {/* PRICING */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1169">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1170"></span>
          Estructura de Precios
        </div>
        <div className="mb-8 grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-1171">
          <div className="rounded-lg border border-[#F5C842] bg-[#0d0d0d] p-5 text-center" data-id="element-1172">
            <div className="mb-2 text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1173">
              Precio Estándar
            </div>
            <div className="mb-1.5 font-heading text-[32px] font-black text-[#F5C842]" data-id="element-1174">
              $350
            </div>
            <div className="text-[11px] leading-[1.5] text-[#666]" data-id="element-1175">
              Sitio web completo + dominio + primer mes de hosting. Pago único
              al cerrar.
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] p-5 text-center" data-id="element-1176">
            <div className="mb-2 text-[9px] font-bold tracking-[2px] text-[#555] uppercase" data-id="element-1177">
              Plan de Pagos
            </div>
            <div className="mb-1.5 font-heading text-[32px] font-black text-white" data-id="element-1178">
              2x$175
            </div>
            <div className="text-[11px] leading-[1.5] text-[#666]" data-id="element-1179">
              $175 al cerrar + $175 a los 30 días. Para clientes que dicen "es
              caro".
            </div>
          </div>
          <div className="rounded-lg border border-[#1e1e1e] bg-[#111] p-5 text-center" data-id="element-1180">
            <div className="mb-2 text-[9px] font-bold tracking-[2px] text-[#555] uppercase" data-id="element-1181">
              Mantenimiento Mensual
            </div>
            <div className="mb-1.5 font-heading text-[32px] font-black text-white" data-id="element-1182">
              $99/mes
            </div>
            <div className="text-[11px] leading-[1.5] text-[#666]" data-id="element-1183">
              Hosting, actualizaciones y soporte. Ofrécelo después de entregar
              el sitio.
            </div>
          </div>
        </div>

        {/* OBJECTIONS */}
        <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1184">
          <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1185"></span>
          Las 5 Objeciones Más Comunes y Cómo Responderlas
        </div>
        <div className="mb-8 grid grid-cols-1 md:grid-cols-2 gap-3.5" data-id="element-1186">
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1187">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-1188">
              ❌ "Es muy caro."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-1189">
              <span className="font-bold text-[#4caf50]" data-id="element-1190">✅ Tu respuesta:</span>{' '}
              "Entiendo. ¿Cuánto le cuesta perder un cliente porque no lo
              encontraron en Google?"
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1191">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-1192">
              ❌ "Ya tengo uno."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-1193">
              <span className="font-bold text-[#4caf50]" data-id="element-1194">✅ Tu respuesta:</span>{' '}
              "¿Puedo verlo? [Pausa] Entiendo. ¿Le gustaría uno que realmente
              traiga clientes?"
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1195">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-1196">
              ❌ "Déjame pensarlo."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-1197">
              <span className="font-bold text-[#4caf50]" data-id="element-1198">✅ Tu respuesta:</span>{' '}
              "Por supuesto. ¿Cuándo podría hablar con usted de nuevo? ¿Mañana a
              las 10?"
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1199">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-1200">
              ❌ "No tengo tiempo."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-1201">
              <span className="font-bold text-[#4caf50]" data-id="element-1202">✅ Tu respuesta:</span>{' '}
              "No se preocupe, yo me encargo de todo. Usted solo me aprueba el
              diseño."
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111] md:col-span-2" data-id="element-1203">
            <div className="flex items-center gap-2 border-b border-[#2a1a1a] bg-[#1a0a0a] px-4 py-2.5 text-[12px] font-bold text-[#ff6b6b]" data-id="element-1204">
              ❌ "No sé si lo necesito."
            </div>
            <div className="px-4 py-3.5 text-[12px] leading-[1.65] text-[#bbb]" data-id="element-1205">
              <span className="font-bold text-[#4caf50]" data-id="element-1206">✅ Tu respuesta:</span>{' '}
              "Entiendo. ¿Sabe cuántas personas buscan{' '}
              <span className="text-[#F5C842]" data-id="element-1207">[tipo de negocio]</span> en
              Google en su ciudad cada mes? Sin sitio web, ninguna de ellas lo
              encuentra a usted."
            </div>
          </div>
        </div>

        {/* FULL SCRIPT */}
        <div className="mb-8" data-id="element-1208">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1209">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1210"></span>
            Guion Completo del Módulo
          </div>

          <div className="mb-4" data-id="element-1211">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1212">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1213"></span>⏱
              0:00 – 0:30 · Introducción
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1214">
              "Módulo 4. El cierre. Sé que para muchos esta es la parte más
              intimidante. Llamar a un extraño y ofrecerle algo. Pero te prometo
              que cuando termines este módulo, vas a ver que no es una venta. Es
              una conversación. Y tienes algo que ellos quieren."
            </div>
          </div>

          <div className="mb-4" data-id="element-1215">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1216">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1217"></span>⏱
              0:30 – 10:00 · El Guion de Cierre
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1218">
              "Voy a darte el guion exacto. Puedes leerlo las primeras veces si
              necesitas. Con el tiempo, será natural."
              <br data-id="element-1219" />
              <br data-id="element-1220" />
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-1221">
                APERTURA (WhatsApp o llamada):
              </span>
              <br data-id="element-1222" />
              "'Hola, ¿hablo con{' '}
              <span className="italic text-[#666]" data-id="element-1223">[Nombre del dueño]</span>? Mi
              nombre es <span className="italic text-[#666]" data-id="element-1224">[Tu nombre]</span>.
              Vi su negocio{' '}
              <span className="italic text-[#666]" data-id="element-1225">[Nombre del negocio]</span>{' '}
              en Google Maps y noté que no tienen sitio web. Tomé 10 minutos y
              preparé una demo de cómo podría verse. ¿Le puedo enviar el link
              para que lo vea?'"
              <br data-id="element-1226" />
              <br data-id="element-1227" />
              "Eso es todo. No vendas nada todavía. Solo pide permiso para
              enviar el link."
              <br data-id="element-1228" />
              <br data-id="element-1229" />
              "Cuando digan que sí (y la mayoría dirá que sí porque es gratis y
              no les pides nada), envía el link de la demo y espera 10 minutos.
              Luego escribe:"
              <br data-id="element-1230" />
              <br data-id="element-1231" />
              <span className="not-italic font-bold text-[#F5C842]" data-id="element-1232">
                SEGUIMIENTO:
              </span>
              <br data-id="element-1233" />
              "'¿Tuvo oportunidad de verlo? ¿Qué le pareció? Puedo tenerlo listo
              y publicado en 48 horas por $350. Incluye el dominio y el primer
              mes de hosting.'"
              <br data-id="element-1234" />
              <br data-id="element-1235" />
              "Si dicen que sí, cobras. Si dicen que es caro, tienes dos
              opciones: ofrecer un plan de pagos ($175 ahora, $175 en 30 días) o
              simplemente pasar al siguiente prospecto. No negocies demasiado.
              Tu tiempo vale."
            </div>
          </div>

          <div className="mb-4" data-id="element-1236">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1237">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1238"></span>⏱
              10:00 – 13:00 · Las 5 Objeciones
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1239">
              "Las 5 objeciones más comunes y cómo responderlas:"
              <br data-id="element-1240" />
              <br data-id="element-1241" />
              "1. 'Es muy caro.' → 'Entiendo. ¿Cuánto le cuesta perder un
              cliente porque no lo encontraron en Google?'"
              <br data-id="element-1242" />
              "2. 'Ya tengo uno.' → '¿Puedo verlo? [Pausa] Entiendo. ¿Le
              gustaría uno que realmente traiga clientes?'"
              <br data-id="element-1243" />
              "3. 'Déjame pensarlo.' → 'Por supuesto. ¿Cuándo podría hablar con
              usted de nuevo? ¿Mañana a las 10?'"
              <br data-id="element-1244" />
              "4. 'No tengo tiempo.' → 'No se preocupe, yo me encargo de todo.
              Usted solo me aprueba el diseño.'"
              <br data-id="element-1245" />
              "5. 'No sé si lo necesito.' → 'Entiendo. ¿Sabe cuántas personas
              buscan [tipo de negocio] en Google en su ciudad cada mes? Sin
              sitio web, ninguna de ellas lo encuentra a usted.'"
            </div>
          </div>

          <div className="mb-4" data-id="element-1246">
            <div className="mb-1.5 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1247">
              <span className="inline-block h-[2px] w-3 bg-[#F5C842]" data-id="element-1248"></span>⏱
              13:00 – 15:00 · Cierre Final del Curso
            </div>
            <div className="whitespace-pre-wrap rounded-r-lg border border-[#1e1e1e] border-l-[3px] border-l-[#F5C842] bg-[#0d0d0d] px-[22px] py-[18px] text-[13px] italic leading-[1.8] text-[#ccc]" data-id="element-1249">
              "Eso es todo. Tienes el sistema completo. Ahora ve y contacta tus
              5 prospectos hoy. No mañana. Hoy. El dinero está ahí afuera
              esperándote. El único paso que falta eres tú."
            </div>
          </div>
        </div>

        {/* TASK */}
        <div className="mb-8 rounded-r-lg border border-[#1a3a1a] border-l-[4px] border-l-[#4caf50] bg-[#0a150a] px-[26px] py-[22px]" data-id="element-1250">
          <div className="mb-2.5 font-heading text-[9px] font-bold tracking-[2px] text-[#4caf50] uppercase" data-id="element-1251">
            ✅ Tu Tarea Final — Módulo 4
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1252">
            Contacta a tus{' '}
            <strong className="text-white" data-id="element-1253">5 prospectos hoy</strong>. No mañana.
            Hoy. Tu objetivo es cerrar al menos 1 venta esta semana.
            <div className="mt-3 flex flex-col gap-2" data-id="element-1254">
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1255">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1256">
                  1
                </div>
                Envía el mensaje de apertura al Prospecto #1 (WhatsApp o
                llamada)
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1257">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1258">
                  2
                </div>
                Cuando diga que sí, envía el link de su demo
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1259">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1260">
                  3
                </div>
                Espera 10 minutos y envía el seguimiento con el precio de $350
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1261">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1262">
                  4
                </div>
                Repite con los 5 prospectos de tu lista
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1263">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1264">
                  5
                </div>
                <strong className="text-white" data-id="element-1265">
                  Objetivo: cerrar al menos 1 venta esta semana
                </strong>
              </div>
            </div>
          </div>
        </div>

        {/* CLOSING BANNER */}
        <div className="mb-8 rounded-lg border border-[#2a2a2a] border-t-[3px] border-t-[#F5C842] bg-black px-10 py-10 text-center" data-id="element-1266">
          <div className="mb-3 font-heading text-[28px] font-black leading-tight text-white" data-id="element-1267">
            Ahora Ve y<br data-id="element-1268" />
            <span className="text-[#F5C842]" data-id="element-1269">Cierra Tu Primer Cliente</span>
          </div>
          <div className="mx-auto max-w-[500px] text-[14px] leading-[1.7] text-[#777]" data-id="element-1270">
            Tienes el sistema completo. Los cerebros de IA. El guion. Las demos.
            El único paso que falta eres tú. El dinero está ahí afuera
            esperándote.
          </div>
        </div>
      </div>

      {/* FOOTER NAV */}
      <div className="mt-5 flex items-center justify-between border-t border-[#1a1a1a] bg-black px-4 py-6 md:px-10" data-id="element-1271">
        <a href="/modulo-3" className="flex items-center gap-1.5 text-[12px] font-bold text-[#555] transition-colors hover:text-white" data-id="element-1272">
          ← Módulo 3
        </a>
        <div className="font-heading text-[11px] font-black tracking-[3px] text-[#333] uppercase" data-id="element-1273">
          AI <span className="text-[#F5C842]" data-id="element-1274">WEB CLOSER</span>
        </div>
        <div className="rounded bg-[#4caf50] px-7 py-3 font-heading text-[12px] font-black tracking-[1px] text-black uppercase" data-id="element-1275">
          ✓ Curso Completado
        </div>
      </div>
    </div>;
}